export class TabsImageStyle {
  width = '';
  border = '';
  boxShadow = '';
  boxDecoration = '';
  imageColumnWidth = 'uk-width-1-2';
  columnGap = '';
  verticalCenter = '';
  marginTop = 'uk-margin-remove-top';

  static normalize(styles: Partial<TabsImageStyle>): TabsImageStyle {
    const pureStyles = new TabsImageStyle();

    pureStyles.width = styles.width ?? pureStyles.width;
    pureStyles.border = styles.border ?? pureStyles.border;
    pureStyles.boxShadow = styles.boxShadow ?? pureStyles.boxShadow;
    pureStyles.boxDecoration = styles.boxDecoration ?? pureStyles.boxDecoration;
    pureStyles.imageColumnWidth = styles.imageColumnWidth ?? pureStyles.imageColumnWidth;
    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.verticalCenter = styles.verticalCenter ?? pureStyles.verticalCenter;
    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
